import { Stack } from 'braid-design-system';
import type React from 'react';

interface Props {
  children: React.ReactNode;
}

const TertiaryLinks = ({ children }: Props) => (
  <Stack space="gutter">
    <>{children}</>
  </Stack>
);

export default TertiaryLinks;
